import createLucideIcon from '../createLucideIcon';

const CircleDot = createLucideIcon('CircleDot', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '1', key: '41hilf' }],
]);

export default CircleDot;
